import { type ReactNode } from 'react';
import CollectionSearch from '@creditflowresearch/uilib/CollectionSearch';
import { useCorporateBondScreenerSidebarFilterContext } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import {
  CorporateBondScreenerSidebarContent,
  SECTIONS_REGISTRY,
  type ISectionEntry,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/CorporateBondScreenerSidebarContent';
import DateFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/DateFilter';
import {
  type CustomizationPanelTabId,
  SearchRow,
} from '@/creditflowresearch/ui/components/bondscreener/CustomizationPanel';
import { CustomizationPanelPresets } from './CustomizationPanelPresets';

import styles from '@/creditflowresearch/ui/components/bondscreener/CustomizationPanel/customizationPanel.module.scss';

interface IFiltersTabContentProps {
  activeTab: CustomizationPanelTabId,
  resetKey: string | number,
}

export const FiltersTabContent = ({ activeTab, resetKey }: IFiltersTabContentProps) => {
  const { resetKey: filterResetKey, isOpen } = useCorporateBondScreenerSidebarFilterContext();

  return (
    <CollectionSearch
      resetKey={ `${ isOpen }-${ filterResetKey }-${ activeTab }` }
      collection={ SECTIONS_REGISTRY }
      getText={ (section: ISectionEntry) => section.searchText }
      emptyCollection={ (query) => (
        <p className={ styles.noResults }>
          No results found for <span className={ styles.noResultsQuery }>&ldquo;{ query }&rdquo;</span>
        </p>
      ) }
      placeholder="Search for specific filter(s)"
      inputName="customizationPanelSearch"
      dataTest="customizationPanelSearch"
    >
      { (input: ReactNode, filteredSections: ISectionEntry[], emptyNode: ReactNode, isSearchActive: boolean) => (
        <>
          <SearchRow input={ input } resetKey={ resetKey } showDateFilter DateFilter={ DateFilter } />
          { !isSearchActive && <CustomizationPanelPresets /> }
          { emptyNode ?? <CorporateBondScreenerSidebarContent key={ filterResetKey } sections={ filteredSections } /> }
        </>
      ) }
    </CollectionSearch>
  );
};
